import React from 'react'

const MwTextArea = ({id,value,onChange,label,placeholder,rows}) => {
    return (
        <>
            { label && 
                <label className='text-xs text-slate-500 ' htmlFor="inv_no">{label}</label>}
            <textarea 
                className='text-xs text-slate-600 border border-slate-300 w-full rounded-md p-2 focus:outline-none focus:ring-1 focus:ring-slate-300 focus:border-slate-500' 
                id={id}
                name={id} 
                value={value} 
                onChange={onChange}  
                placeholder={placeholder}
                rows={rows} 
                style={{resize: 'none'}}
                >
                                        
            </textarea>
        </>
    )
}

export default MwTextArea
